import { jsx as e, jsxs as t } from "react/jsx-runtime";
import h from "classnames";
import m from "lodash.uniqueid";
import { I as x } from "../../chunks/icon-96vzN0aU.js";
const _ = "_tickBoxWrapper_l55zw_1", d = "_labelWrapper_l55zw_10", b = "_checkbox_l55zw_16", f = "_checked_l55zw_27", u = "_labelText_l55zw_31", W = "_checkmark_l55zw_40", c = {
  tickBoxWrapper: _,
  labelWrapper: d,
  checkbox: b,
  checked: f,
  labelText: u,
  checkmark: W
}, B = ({
  checked: a,
  children: s,
  className: p,
  name: r = "check",
  onClick: o,
  shouldUseUniqueId: k,
  testId: l
}) => {
  const n = (i) => {
    i.preventDefault(), o && o();
  };
  return /* @__PURE__ */ e("div", { className: h(c.tickBoxWrapper, p), "data-testid": l, onClick: n, children: /* @__PURE__ */ t("label", { children: [
    /* @__PURE__ */ e(
      "input",
      {
        autoComplete: "off",
        "data-testid": l ? `${l}-checkbox` : void 0,
        defaultChecked: a,
        id: k ? m(r) : r,
        type: "checkbox"
      }
    ),
    /* @__PURE__ */ t("span", { className: c.labelWrapper, children: [
      /* @__PURE__ */ e("span", { className: `${c.checkbox} ${a ? c.checked : ""}`, children: a ? /* @__PURE__ */ e("span", { className: c.checkmark, children: /* @__PURE__ */ e(x, { fill: "#00182e", icon: "Checkmark" }) }) : null }),
      /* @__PURE__ */ e("span", { className: c.labelText, children: s })
    ] })
  ] }) });
};
export {
  B as default
};
